var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmation2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 72,
    viewBox: "0 0 104 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1428 28.2848C96.5017 58.4456 71.9294 71.9991 52.5559 71.9991C33.1825 71.9991 8 55.7086 8 38.3582C8 21.0078 12.6244 10.2035 32.1126 3.51306C51.6008 -3.17735 91.784 -1.87594 94.1428 28.2848Z",
    fill: "#F7F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27393_18645)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.5602,
    cy: 37.7281,
    rx: 15.361,
    ry: 15.3609,
    fill: "#E2E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3268 27.8543C70.78 34.3531 69.9323 44.0421 63.4334 49.4953L43.6858 25.9609C50.1846 20.5078 59.8736 21.3555 65.3268 27.8543Z",
    fill: "#EFEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4114 23.4277C52.6968 23.4277 52.1174 22.8484 52.1174 22.1338L52.1174 19.6803C52.1174 18.9657 52.6968 18.3864 53.4114 18.3864C54.126 18.3864 54.7054 18.9657 54.7054 19.6803L54.7054 22.1338C54.7054 22.8484 54.126 23.4277 53.4114 23.4277Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1689 18.3858C48.1689 17.6711 48.7483 17.0918 49.4629 17.0918L57.3602 17.0918C58.0748 17.0918 58.6542 17.6711 58.6542 18.3858C58.6542 19.1004 58.0748 19.6797 57.3602 19.6797L49.4629 19.6797C48.7483 19.6797 48.1689 19.1004 48.1689 18.3858Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9509 48.7884C61.8246 47.7056 63.3925 46.1645 64.5074 44.3098C65.6223 42.455 66.2477 40.3474 66.3248 38.1848C66.402 36.0221 65.9285 33.8753 64.9486 31.9458C63.9688 30.0163 62.5148 28.3673 60.723 27.1537C58.9313 25.9401 56.8606 25.2017 54.7053 25.0076C52.55 24.8136 50.3807 25.1703 48.401 26.0444C47.7472 26.333 46.9833 26.037 46.6946 25.3833C46.406 24.7295 46.702 23.9656 47.3557 23.6769C49.7365 22.6258 52.3453 22.1967 54.9373 22.4301C57.5294 22.6635 60.0196 23.5516 62.1744 25.011C64.3291 26.4705 66.0777 28.4535 67.2561 30.774C68.4345 33.0944 69.004 35.6762 68.9111 38.2771C68.8183 40.8779 68.0662 43.4125 66.7254 45.6431C65.3846 47.8736 63.4991 49.7269 61.2458 51.0291C58.9925 52.3312 56.4453 53.0395 53.8432 53.0875C51.2411 53.1355 48.6695 52.5216 46.3697 51.3034C45.7382 50.9689 45.4975 50.1858 45.832 49.5543C46.1665 48.9227 46.9496 48.682 47.5811 49.0165C49.4934 50.0294 51.6318 50.5399 53.7955 50.5C55.9592 50.4601 58.0772 49.8711 59.9509 48.7884Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4113,
    cy: 37.7368,
    r: 3.03755,
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7432 37.3097C53.2726 36.7719 53.3271 35.9544 53.8649 35.4838L57.3289 32.4528C57.8667 31.9822 58.6842 32.0367 59.1548 32.5745C59.6254 33.1123 59.5709 33.9298 59.0331 34.4004L55.5691 37.4314C55.0313 37.902 54.2138 37.8476 53.7432 37.3097Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7356 32.7646C43.7356 33.4793 43.1563 34.0586 42.4416 34.0586L36.0918 34.0586C35.3772 34.0586 34.7978 33.4793 34.7978 32.7646C34.7978 32.05 35.3772 31.4706 36.0918 31.4706L42.4416 31.4706C43.1563 31.4706 43.7356 32.05 43.7356 32.7646Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7085 38.04C44.7085 38.7547 44.1292 39.334 43.4145 39.334L32.5324 39.334C31.8178 39.334 31.2385 38.7547 31.2385 38.04C31.2385 37.3254 31.8178 36.746 32.5324 36.746L43.4145 36.746C44.1292 36.746 44.7085 37.3254 44.7085 38.04Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2219 43.1767C44.2219 43.8914 43.6426 44.4707 42.928 44.4707L35.6047 44.4707C34.89 44.4707 34.3107 43.8914 34.3107 43.1767C34.3107 42.4621 34.89 41.8828 35.6047 41.8828L42.928 41.8828C43.6426 41.8828 44.2219 42.4621 44.2219 43.1767Z",
    fill: "#8E8CEE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14638 17.704C7.37038 16.392 9.19438 14.944 10.6184 13.36C12.0424 11.776 12.7544 10.248 12.7544 8.776C12.7544 7.992 12.5064 7.368 12.0104 6.904C11.5304 6.424 10.8504 6.184 9.97038 6.184C9.13838 6.184 8.43438 6.344 7.85838 6.664C7.29838 6.968 6.74638 7.368 6.20238 7.864L5.29038 6.544C5.61038 6.144 6.06638 5.736 6.65838 5.32C7.26638 4.904 7.97038 4.56 8.77038 4.288C9.57038 4 10.3784 3.856 11.1944 3.856C12.3624 3.856 13.3384 4.056 14.1224 4.456C14.9224 4.856 15.5144 5.384 15.8984 6.04C16.2824 6.696 16.4744 7.424 16.4744 8.224C16.4744 9.76 15.7384 11.304 14.2664 12.856C12.7944 14.408 10.9224 15.832 8.65038 17.128L15.6104 16.48L16.5224 14.464L18.0344 14.776L17.3384 19H5.65038L5.14638 17.704Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27393_18645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.7143,
    height: 43.7143,
    fill: "white",
    transform: "translate(29.8572 14.1426)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation2);
export default __webpack_public_path__ + "static/media/confirmation2.bb5464c15e0ec23885a67d810d97c451.svg";
export { ForwardRef as ReactComponent };